import { Container, Flex } from 'pcln-design-system'
import { type ReactNode } from 'react'

export default function AdBanner({ children }: { children?: ReactNode }) {
  return (
    <Flex alignItems='center' justifyContent='center'>
      <Container maxWidth={728} maxHeight={120}>
        {children}
      </Container>
    </Flex>
  )
}
